module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-36.7eeab54d.png";